import { useState } from "react";
import { NAVIGATION_STATES } from "../constants";

const useOptNavigation = () => {
  const [navigationState, setNavigationState] = useState(NAVIGATION_STATES.WELCOME);

  const handleOptIn = () => {
    // @TODO should we still needing this?
    // await approveSubmission({ id: submissionId });
    setNavigationState(NAVIGATION_STATES.OPT_IN);
  };

  const handleOptOut = () => setNavigationState(NAVIGATION_STATES.OPT_OUT);
  const handleWelcome = () => setNavigationState(NAVIGATION_STATES.WELCOME);

  const handleFilledOut = () => setNavigationState(NAVIGATION_STATES.FILLED_OUT);
  const handleSubmitted = () => setNavigationState(NAVIGATION_STATES.SUBMITTED);
  const handleError = () => setNavigationState(NAVIGATION_STATES.ERROR);

  return {
    handleError,
    handleFilledOut,
    handleSubmitted,
    handleOptIn,
    handleOptOut,
    handleWelcome,
    navigationState
  };
};

export { useOptNavigation };
